<template>
  <div v-on:click="openDorm()" class="banner-card">
    <div class="banner-card__wrp">
      <img
        :src="banner.cover"
        v-if="banner.cover"
        alt="" class="banner-card__cover">
      <div class="banner-card__content" :style="{ background: convertHex(banner.color) }">
        <div class="banner-card__head">
          <div class="banner-card__title">{{ banner.top_title }}</div>
          <div class="banner-card__txt" :style="{ textShadow: `${banner.color} 2px 1px 1px` }">{{ banner.bottom_title }}</div>
        </div>
        <div class="banner-card-logo" v-if="banner.logo" >
          <img :src="banner.logo" alt="" class="banner-card-logo__img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'BannerItem',
  props: {
    banner: Object,
    to: [String, Object]
  },
  data () {
    return {
      branchedBanner: false,
      branches: [],
      opacity: 50
    }
  },
  methods: {
    string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },     
  getDetail() {
    var self = this
        const url = self.$attrs.redirect ? `/site/dorm/detail/old/${this.to.params.id}` : `/site/dorm/detail/${this.to.params.id}`
       //const url = `/site/dorm/detail/${this.to.params.id}`
       axios.get(url)
         .then(response => {
           this.isLoading = false
           self.detail = response.data
           if(response.data.branches.length > 1) {
             window.localStorage.setItem('branchedDormId', this.to.params.id)
             window.localStorage.setItem('dormLogo', response.data.dorm.logo)
             window.localStorage.setItem('dormWeb', response.data.dorm.web)
             let dorm = this.string_to_slug(this.banner.top_title)
             let route = { name: 'Branch', params: { dorm: dorm } }
             self.$router.push(route)
            //  self.$router.push('/' + this.string_to_slug(this.banner.top_title) + '-subeler/')
           } else {
             if(self.mobileCheck()) {
              self.$router.push(this.to)
              } else {
              window.open(window.location.origin + '/' + this.to.params.slug + '-y-' + this.to.params.id, '_blank')
              }             
           }
           
    })
  },
    convertHex (color) {
      color = color.replace('#', '')
      let r = parseInt(color.substring(0, 2), 16)
      let g = parseInt(color.substring(2, 4), 16)
      let b = parseInt(color.substring(4, 6), 16)
      // let result = 'rgba(' + r + ',' + g + ',' + b + ',' + this.opacity / 100 + ')'
      let result = `linear-gradient(90deg,rgb(${r},${g},${b}) 15%,rgba(${r},${g},${b},.85) 40%,rgba(${r},${g},${b},0))`
      return result
    },
    mobileCheck () {
        var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
  },
    openDorm () {
       this.getDetail()
/*              if(this.mobileCheck()) {
              this.$router.push(this.to)
              } else {
              window.open(window.location.origin + '/' + this.to.params.slug + '-y-' + this.to.params.id, '_blank')
              }   */       
    }  
  },
  computed: {
    getMobile() {
    let result = this.mobileCheck()
    return result
    }
  },
  created () {
    if(this.banner.top_title.includes('Yurtları')) {
         window.localStorage.setItem('branchedDormTitle', this.banner.top_title)
    }
  }

}
</script>
<style lang="scss">
  @import "../assets/scss/components/banner";
</style>
